import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { FormControl, Validators } from '@angular/forms';
import { HttpService } from '../../../services/http/http.service';
import { LocalstorageService } from '../../../services/localstorage/localstorage.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';


@Component({
  selector: 'app-registeration',
  templateUrl: './registeration.component.html',
  styleUrls: ['./registeration.component.scss']
})
export class RegisterationComponent implements OnInit {
  disabled: boolean = false;
  showOtp: boolean = false;
  data: any = {};
  nameExp = '[a-zA-Z ]*$';
  contactExp = '^[6-9]{1}[0-9]{9}$';
  emailExp = '^([a-zA-Z0-9][.-_]?)+@([a-zA-Z0-9]+[.-]?)*[a-zA-Z0-9][.][a-zA-Z]{2,3}$';
  userId = "";
  cid = "";
  uid = "";
  otp = "";
  phoneNumber1 = "";
  textBoxDisabled = false;
  token = "";
  token1 = "";
  constructor(public dialog: MatDialog,
    private httpService: HttpService,
    private localstorageService: LocalstorageService,
    private spinnerService: Ng4LoadingSpinnerService,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      this.cid = params['cid'];
      this.token1 = params['token'];
      // this.uid = params['uid'];
      this.otp = params['otp'];
      console.log(this.cid);
    });

  }

  ngOnInit() {
    // if(this.uid!=null && this.uid!=undefined && this.uid!="" && this.otp!=null && this.otp!=undefined && this.otp!="")
    if (this.otp != null && this.otp != undefined && this.otp != "") {
      localStorage.setItem('token', this.token1);
      this.OTP = new FormControl(this.otp, [Validators.required, Validators.pattern(this.contactExp), this.noWhitespaceValidator]);
      // this.userId=this.uid;
      this.verifyOTP();
    }
  }
  fullName = new FormControl(null, [Validators.required, Validators.pattern(this.nameExp),
  this.noWhitespaceValidator, Validators.minLength(2)]);
  email = new FormControl(null, [Validators.required, Validators.pattern(this.emailExp)]);
  phoneNumber = new FormControl(null, [Validators.required, Validators.pattern(this.contactExp)]);
  OTP = new FormControl(null, [Validators.required, Validators.pattern(this.contactExp), this.noWhitespaceValidator]);
  onRightClick(event) {
    console.log("right click");
    // this.nRightClicks++;
    return false;
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }
  getErrorForEmail() {
    return this.email.hasError('required') ? 'Email can\'t be blank' :
      this.email.hasError('email') ? 'Please provide proper email' :
        this.email.hasError('pattern') ? 'Please provide proper email' : '';
  }
  getErrorForOTP() {
    return this.OTP.hasError('required') ? 'OTP can\'t be blank' :
      this.OTP.hasError('whitespace') ? 'Please provide valid OTP' :
        '';
  }

  getErrorForPhoneNumber() {
    return this.phoneNumber.hasError('required') ? 'Phone number can\'t be blank' :
      this.phoneNumber.hasError('pattern') ? 'Please provide valid phone number' : '';
  }
  getErrorForFullName() {
    return this.fullName.hasError('required') ? 'Full name can\'t be blank' :
      this.fullName.hasError('whitespace') ? 'Please provide valid full name' :
        this.fullName.hasError('pattern') ? 'Full name can\'t contains digits or any special character' :
          this.fullName.hasError('minlength') ? 'Full name length should be greater than 1' : '';

  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    console.log(event.keyCode);
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
      return false;
    }

  }
  keyPressButton(event: any) {
    if (event.keyCode === 13) {
      this.register();
    }
  }
  keyPressButton1(event: any) {
    if (event.keyCode === 13) {
      this.verifyOTP();
    }
  }
  keyUpPhone(event: any) {
    // const pattern = /[0-9]/;

    // console.log(event );
    // let inputChar = String.fromCharCode(event.charCode);
    // if (event.keyCode != 8 && !pattern.test(inputChar)) {
    //   event.preventDefault();
    // }
    //      console.log(this.phoneNumber1);
    //      var value=this.phoneNumber1;
    //     var kCd = event.keyCode || event.which;
    //     if (kCd == 0 || kCd == 229) { //for android chrome keycode fix
    //       kCd = this.lastKeyCode(this.phoneNumber1);

    //       var subStr = value.substr(value.length - 1);
    //       console.log(subStr);
    //       if(!pattern.test(subStr)) {
    // console.log("in");
    // // this.phoneNumber1="abcd"
    //           //if(value.length >0){
    //             // this.phoneNumber1="abcd"
    //             console.log("jjj : "+value.substr(0, (value.length - 1)));
    //             this.phoneNumber1=(value.substr(0, (value.length - 1)));
    //             //this.phoneNumber=this.phoneNumber.value.substr(0, (this.phoneNumber.value.length - 1));
    //           // }else{
    //           //   // this.phoneNumber.setValue("dd");
    //           //   // this.phoneNumber =new FormControl("", [Validators.required, Validators.pattern(this.contactExp),
    //  Validators.pattern(this.contactExpLength)]);
    //           //   this.phoneNumber1='';
    //           // }

    //       }
    //       else{
    //         this.phoneNumber1=this.phoneNumber1+subStr;
    //       }
    //     }

  }

  lastKeyCode(str) {
    return str.charCodeAt(str.length - 1);
  }

  register() {
    this.data = {
      fullName: this.fullName.value.trim(),
      emailId: this.email.value.trim(),
      phoneNumber: this.phoneNumber.value.trim(),
      cId: this.cid
    }

    if (this.data.fullName && this.data.emailId && this.data.phoneNumber != null) {
      this.spinnerService.show();
      console.log("model: ", this.data);
      var contentBody = { url: "/users", body: this.data }
      this.httpService.httpPost(contentBody, false).subscribe(response => {
        console.log("success ", response);
        this.userId = response["id"];
        this.token = response["token"];
        this.localstorageService.setData('token', this.token)
        this.localstorageService.setData('userId', this.userId)
        this.fullName.setValue(this.fullName.value.trim())
        this.email.setValue(this.email.value.trim())
        // console.log(response["user"].id)
        this.showOtp = true;
        this.textBoxDisabled = true;
        this.disabled = true;
        this.spinnerService.hide();
        this.OTP = new FormControl("", [Validators.required, Validators.pattern(this.contactExp), this.noWhitespaceValidator]);
        // if(response == undefined) {
        //   this.openSnackBar("Network Error")
        // }
        // else {
        this.openSnackBar(response["message"]);

        // }
      }, error => {
        console.log("err ", error);
        this.showOtp = false;
        this.textBoxDisabled = false;
        this.disabled = false;
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      })
    }
    else {
      this.showOtp = false;
    }
  }

  verifyOTP() {
    console.log("Verify OTP");
    var data = {
      otp: this.OTP.value
    }
    if (data.otp) {
      this.spinnerService.show();
      var contentBody = { url: "/users/verifyotp", body: data }
      this.httpService.httpPost(contentBody, true).subscribe(response => {
        console.log("success ", response);
        if (response["testAttemptCount"] >= response["maxAttemptCount"]) {
          this.spinnerService.hide();
          this.openSnackBar("Your Maximum trial exceed")
          // window.location.reload();
        }
        else {
          this.localstorageService.setData("token", response["token"])
          this.localstorageService.setData("userId", response["id"])
          this.localstorageService.setData("name", response["name"]);
          if (response["location"] != undefined && response["location"] != null && response["location"] != "") {
            this.localstorageService.setData("location", response["location"]);
          }
          else {
            this.localstorageService.setData("location", "");
          }

          this.spinnerService.hide();
          // this.openSnackBar("sdfwf");
          this.httpService.redirectTo("/test");
        }

      }, error => {
        console.log("error ", error);
        this.spinnerService.hide();
        this.openSnackBar(error.error.message);
      })
    }
    else {

    }
  }

  resendOTP() {
    this.spinnerService.show();
    var contentBody = { url: "/users/resendotp" }
    this.httpService.httpPost(contentBody, true).subscribe(response => {
      console.log("success ", response);

      this.spinnerService.hide();
      this.openSnackBar(response["message"]);

    }, error => {
      console.log("error ", error);
      this.spinnerService.hide();
      this.openSnackBar(error.error.message);
    })

  }
  openSnackBar(message: string) {
    if (message == null || message == "" || message == undefined) {
      this.snackbar.open("Network Error", null, {
        duration: 5000
      });
    }
    else {
      this.snackbar.open(message, null, {
        duration: 5000
      });
    }
  }

  focusOutFunction() {
    var data = {
      emailId: this.email.value
    }
    this.spinnerService.show();
    var contentBody = { url: "/users/getuserdata", body: data }

    this.httpService.httpPost(contentBody, false).subscribe(response => {
      // console.log("success ", response);
      this.fullName.setValue(response["fullName"])
      this.spinnerService.hide();
      // this.openSnackBar(response["message"]);

    }, error => {
      // console.log("error ", error);
      this.spinnerService.hide();
      // this.openSnackBar(error.error.message);
    })
  }
}
